import type {
    IAdminLoyaltyLeaderboardResponse,
    IAdminLoyaltyLeaderboardUser,
} from '../types/global/buzzbridgeLoyalty.types';

function normalizeLeaderboardRow(row: any, index: number): IAdminLoyaltyLeaderboardUser | null {
    const user = row?.user ?? row;
    const userId = user?.id ?? user?._id ?? row?.user_id;
    if (!userId) return null;

    return {
        rank: row.rank ?? index + 1,
        user: {
            id: String(userId),
            name: user.name ?? ([user.firstName, user.lastName].filter(Boolean).join(' ') || undefined),
            username: user.username ?? user.userName,
            email: user.email,
            profile_photo: user.profile_photo ?? user.profile_picture,
        },
        points_balance: row.points_balance ?? row.points?.balance ?? row.loyalty_points?.balance ?? 0,
        lifetime_points_earned:
            row.lifetime_points_earned ?? row.points?.lifetime_earned ?? row.loyalty_points?.lifetime_earned ?? 0,
        cash_balance_cents: row.cash_balance_cents ?? row.cash?.balance_cents ?? row.cash_wallet?.balance_cents ?? 0,
        lifetime_cash_earned_cents:
            row.lifetime_cash_earned_cents ??
            row.cash?.lifetime_earned_cents ??
            row.cash_wallet?.lifetime_earned_cents ??
            0,
        referral_count: row.referral_count ?? row.referrals?.count ?? 0,
        referral_cash_earned_cents: row.referral_cash_earned_cents ?? row.referrals?.cash_earned_cents,
    };
}

export function normalizeAdminLoyaltyLeaderboardResponse(raw: any): IAdminLoyaltyLeaderboardResponse {
    const list = raw?.items ?? raw?.members ?? raw?.results ?? raw?.leaderboard ?? raw?.rows ?? [];
    const members = (Array.isArray(list) ? list : [])
        .map(normalizeLeaderboardRow)
        .filter((row): row is IAdminLoyaltyLeaderboardUser => row != null);

    const pagination = raw?.pagination ?? {
        page: raw?.page ?? 1,
        limit: raw?.limit ?? raw?.pageSize ?? 25,
        total: raw?.total ?? raw?.totalCount ?? members.length,
        total_pages: raw?.total_pages ?? raw?.totalPages ?? 1,
    };

    return { members, pagination };
}
